
<div class="container flex flex_xs_column">
	<app-product-search-filter-form
		[filtersGroups]="filterGroups"
		[activeFilters]="activeFilters"
		[searchInput]="searchInput"
		[bLoading]="filtersLoading"
		[totalAmountOfProducts]="productsPagination.total"
	></app-product-search-filter-form>

	<div class="flex1 margin_left_large" tabindex="0" #containerProducts [attr.aria-label]="'Listado de productos, '+ productsPagination.total +' en total, página'+ productsPagination.current_page +' de '+ productsPagination.last_page +', '+ productsPagination.per_page +' por página'">

		<ng-container *ngIf="productsPagination.data.length; else noProducts;">
			<div class="flex_wrap gap_large">
				<div class="third_width" *ngFor="let p of productsPagination.data">
					<app-product-card [product]="p" [loggedUserStoreId]="loggedUserStoreId"></app-product-card>
				</div>
			</div>
	
			<app-async-simple-paginator
				[pagination]="productsPagination"
				[bLoading]="productsLoading"
				wrapper_classes="margin_top_very_large"
				(eePageChange)="onPageChange($event)"
			></app-async-simple-paginator>
		</ng-container>

		<ng-template #noProducts>
			<app-no-elements-template caption="Nada por aquí" img_src="/assets/img/artwork25.svg" wrapper_classes="margin_top_very_large"></app-no-elements-template>
		</ng-template>
	</div>
</div>